import localAxios from  '@/services/axiosPermisos'

import  {
    path
} from './path'

import {
    map_query
} from '@/core/functions/map-path-query'

async function getTypeAbsenteeismService (data = {})
{
    return await localAxios.get(path.typesAbsenteeism.concat(map_query(data)), true, 'v2')
}

async function getAbsenceSenderService (data = {})
{
    return await localAxios.get(path.absenceSender.concat(map_query(data)), true, 'v2')
}

async function getEmployeesService (data = {})
{
    return await localAxios.get(path.employees.concat(map_query(data)), true, 'v2')
}

async function getDiagnosticGroupsService (data = {})
{
    return await localAxios.get(path.diagnosticGroups.concat(map_query(data)), true, 'v2')
}

async function getTimeOfAbsenceService (data= {}) {
    return await localAxios.get(path.timeOfAbsences.concat(map_query(data)), true, 'v2')
}


export {
    getTypeAbsenteeismService
    , getAbsenceSenderService
    , getEmployeesService
    , getDiagnosticGroupsService
    , getTimeOfAbsenceService
}